import { BUCKET_READBOOKS_URL } from "../global-components/src/utils/vars";
import { GoogleBooks, GoogleBooksItem } from "../types";

export function getGoogleBookImage(book?: GoogleBooksItem, increaseQuality?: boolean): string {
    if(!book) return '/img/book_transparent.png';

    let thumbnail = book?.volumeInfo?.imageLinks?.smallThumbnail ?? '../img/book_transparent.png';
    thumbnail = book.volumeInfo?.imageLinks?.thumbnail ?? thumbnail;
    thumbnail = thumbnail.replace('http://books.google.com', 'https://books.google.com');

    if (thumbnail.includes('books.google.com') && increaseQuality)
        return thumbnail.replace('zoom=5', 'zoom=6');

    return thumbnail;
}